import Vue from 'vue';
import productPackagingTransformer from './../../transformers/productPackaging';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productPackagingTransformer.fetch(errors));
};

export default productPackaging => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('product_packagings', productPackaging)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productPackaging/store.js